export function useCommonMethods(
  resumen,
  ModalRefConfirmDelete,
  openModalTemplate,
  closeModalTemplate
) {
  const includesWords = () => {
    let i = 0;
    while (i < array.length && !resumen.value.formType.includes(array[i])) {
      i++;
    }
    return i < array.length ? true : false;
  };

  const confirmDelete = (modalName) => {
    return new Promise((resolve) => {
      openModalTemplate(modalName);

      const confirmHandler = () => {
        resolve(true);
        ModalRefConfirmDelete.value.$off("confirm", confirmHandler);
        ModalRefConfirmDelete.value.$off("cancel", cancelHandler);
        closeModalTemplate(modalName);
      };

      const cancelHandler = () => {
        resolve(false);
        ModalRefConfirmDelete.value.$off("confirm", confirmHandler);
        ModalRefConfirmDelete.value.$off("cancel", cancelHandler);
        closeModalTemplate(modalName);
      };

      ModalRefConfirmDelete.value.$on("confirm", confirmHandler);
      ModalRefConfirmDelete.value.$on("cancel", cancelHandler);
    });
  };

  return {
    includesWords,
    confirmDelete,
  };
}
